<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">学生管理({{ countStu }})</div>
        <div slot="right">
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            theme="dark"
            placement="bottom-end"
            @select="onOperate"
          >
            <template #reference>
              操作
            </template>
          </van-popover>
        </div>
      </nav-bar>

      <van-cell title="添加学生" size="large" is-link to="AddStudent"/>

      <!--      <van-cell title="清空学生" @click="delAllStudent" style="color: red;text-align: center"/>-->


      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />

    </van-sticky>

    <van-list
      :finished="true"
      finished-text="搜索查找更多"
      loading-text="努力加载中"
    >
      <van-swipe-cell v-for="item in studentList" :key="item.id">
        <!--        <template slot="left">-->
        <!--          <van-button square type="primary" text="选择"/>-->
        <!--        </template>-->
        <van-cell :border="false" :title="item.sName+' '+item.gender+' '+item.sNum" value="<<滑动<<"/>
        <template slot="left">
          <van-button square type="primary" @click="detail(item)" text="详细"/>
        </template>
        <template slot="right">
          <van-button square type="danger" @click="delStudent(item.id)" text="删除"/>
          <van-button square type="warning" @click="resetStuPwd(item.id)" text="重置"/>
          <van-button square type="primary" @click="loginUnlock(item.sNum)" text="解锁"/>
          <van-button square color="linear-gradient(to right, #ff6034, #ee0a24)" @click="unbind(item.id)"
                      text="解绑"/>
        </template>
      </van-swipe-cell>
    </van-list>
    <van-dialog v-model="multipleResetShow" title="选择重置类型" show-cancel-button @confirm="multipleResetPwd"
                :show-confirm-button="delOrResetCount!=0">
      <van-field name="radio" label="重置年级">
        <template #input>
          <van-radio-group @change="delOrResetChange" v-model="grade" direction="horizontal">
            <van-radio :name="item" v-for="(item,index) in grades" :key="index">{{ item }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="重置层次">
        <template #input>
          <van-radio-group @change="delOrResetChange" v-model="level" direction="horizontal">
            <van-radio name="专升本">专升本</van-radio>
            <van-radio name="本科">本科</van-radio>
            <van-radio name="专科">专科</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-divider content-position="center">{{ grade }} {{ level }} {{ delOrResetCount }}人</van-divider>

    </van-dialog>
    <van-dialog v-model="delMultipleStudentShow" title="选择删除类型" show-cancel-button @confirm="delMultipleStudent"
                :show-confirm-button="delOrResetCount!=0">
      <van-field name="radio" label="删除年级">
        <template #input>
          <van-radio-group @change="delOrResetChange" v-model="grade" direction="horizontal">
            <van-radio :name="item" v-for="(item,index) in grades" :key="index">{{ item }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="删除层次">
        <template #input>
          <van-radio-group @change="delOrResetChange" v-model="level" direction="horizontal">
            <van-radio name="专升本">专升本</van-radio>
            <van-radio name="本科">本科</van-radio>
            <van-radio name="专科">专科</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="pwd" label="删除密码" placeholder="请输入删除密码"/>
      <van-divider content-position="center">{{ grade }} {{ level }} {{ delOrResetCount }}人</van-divider>

    </van-dialog>
    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Cell,
  Search,
  List,
  SwipeCell,
  Button,
  Dialog,
  Toast,
  Sticky,
  Pagination,
  Popover,
  RadioGroup,
  Radio,
  Form,
  Field,
  Divider
} from 'vant';
import NavBar from "components/common/navbar/NavBar";
import {
  getStuListLikeKeyByPage,
  DelStudentById,
  DelAllStudent,
  GetStudentCountByKey,
  ResetPwdByStuId,
  ResetMultipleStuPwd,
  DelMultipleStudent,
  DelOrResetCount
} from "../../../network/student";
import {
  LoginUnlock,
  LoginUnbind
} from "@/network/publics";

Vue.use(Cell)
Vue.use(Search)
Vue.use(List)
Vue.use(SwipeCell)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Sticky)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Form)
Vue.use(Field)
Vue.use(Divider)
export default {
  name: "StuList",
  components: {
    NavBar
  },
  data() {
    return {
      // Popover
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{text: '密码重置'}, {text: '学生删除'}],
      multipleResetShow: false,
      delMultipleStudentShow: false,
      grades: ['2021', '2020', '2019', '2018', '2017'],
      grade: '2021',
      level: '专升本',
      studentList: [],
      searchValue: '',
      countStu: 0,
      pwd: '',


      delOrResetCount: 0,
      //分页
      currentPage: 0
    }
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  activated() {
    const years = this.GLOBAL.years;
    this.grades = [];
    for (let i = 0; i < 6; i++) {
      this.grades.push(years - i);
    }

    GetStudentCountByKey(this.searchValue).then(res => {
      this.countStu = res;
    });
    this.getStuListLikeKeyByPage("");
  },
  methods: {
    onSearch(val) {
      this.getStuListLikeKeyByPage(this.searchValue);
      GetStudentCountByKey(this.searchValue).then(res => {
        this.countStu = res;
      });
    },
    onCancel() {
      this.getStuListLikeKeyByPage("");
      GetStudentCountByKey("").then(res => {
        this.countStu = res;
      });
    },
    onPageChange() {
      this.getStuListLikeKeyByPage(this.searchValue, this.currentPage);
    },
    getStuListLikeKeyByPage(name, page = 1) {
      getStuListLikeKeyByPage(name, page).then(res => {
        this.studentList = res;
      });
    },
    onOperate({text}) {
      if (text == "密码重置") {
        this.multipleResetShow = true;
        return;
      }
      if (text == "学生删除") {
        this.delMultipleStudentShow = true;
        return;
      }
    },
    multipleResetPwd() {
      Dialog.confirm({
        title: '提示',
        message: '确定要重置' + this.grade + this.level + '的所有密码吗'
      }).then(() => {
        ResetMultipleStuPwd(this.grade, this.level).then(res => {
            Toast.success('重置了' + this.grade + this.level + res + '人的密码');
          }
        ).catch(res => {
          Toast.fail('重置失败');
        })
      }).catch(() => {
        // on cancel
      });
    }, delMultipleStudent() {
      if (this.pwd.trim() == "") {
        Toast.fail('删除密码不能为空');
        return
      }
      Dialog.confirm({
        title: '提示',
        message: '确定要删除' + this.grade + this.level + '的所有学生'
      }).then(() => {
        DelMultipleStudent(this.pwd, this.grade, this.level).then(res => {
            Toast.success('删除了' + this.grade + this.level + res + '人');
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
      }).catch(() => {
        // on cancel
      });
    },
    delStudent(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelStudentById(id).then(res => {
            if (res) {
              this.studentList = this.studentList.filter(item => item.id != id);
              this.countStu = this.countStu - 1;
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        );
        // on confirm
      }).catch(() => {
        Toast.fail('删除失败');
        // on cancel
      });
    }, resetStuPwd(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要重置吗'
      }).then(() => {
        ResetPwdByStuId(id).then(res => {
            if (res) {
              Toast.success('重置成功');
            } else {
              Toast.fail('重置失败');
            }
          }
        );
        // on confirm
      }).catch(() => {
        Toast.fail('重置失败');
        // on cancel
      });
    }, loginUnlock(sNum) {
      Dialog.confirm({
        title: '提示',
        message: '确定要解锁吗'
      }).then(() => {
        LoginUnlock(sNum).then(res => {
          if (res) {
            Toast.success('解锁成功');
          } else {
            Toast.fail('解锁失败');
          }
        })
        // on confirm
      })
    }, unbind(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要接触与微信的绑定吗'
      }).then(() => {
        LoginUnbind(id).then(res => {
          if (res) {
            Toast.success('解绑成功');
          } else {
            Toast.fail('解绑失败');
          }
        })
        // on confirm
      })
    },
    delAllStudent() {
      Dialog.confirm({
        title: '警告',
        message: '确定要删除所有学生吗'
      }).then(() => {
        DelAllStudent().then(res => {
          if (res) {
            this.studentList = [];
            Toast.success('刪除成功');
          } else {
            Toast.fail('删除失败');
          }
        }).catch(res => {
          Toast.fail('删除失败');
        })
      }).catch(() => {
      });
    },
    onClickLeft() {
      this.$router.replace("/home");
    },
    detail(item) {
    //   this.$router.push({path: 'StuDetail', query:
    //       {id: item.id, gId:item.gId,sName:item.sName,sNum:item.sNum,classes:item.classes,school:item.school}})
    //
      this.$router.push({path: 'StuDetail', query:
          {...item}})

    },
    delOrResetChange() {
      DelOrResetCount(this.grade, this.level).then(res => {
        this.delOrResetCount = res;
      })
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}
</style>
